'use client'

import { useCallback, useRef } from 'react'
import { solve } from '~/lib/client/pow'

interface Challenge {
  token: string
  nonce: string
  difficulty: number
}

interface PowPayload {
  pow: string
  pow_nonce: string
}

export function useChallenge() {
  const cache = useRef<PowPayload | null>(null)

  const challenge = useCallback(async (): Promise<PowPayload> => {
    const res = await fetch('/api/auth/challenge')
    const data: Challenge = await res.json()
    const counter = await solve(data.nonce, data.difficulty)
    const payload = { pow: data.token, pow_nonce: counter }
    cache.current = payload
    return payload
  }, [])

  return { challenge }
}
